import Notes from 'midi/Notes.js';

export function findClosest(transpose, samplers) {
    let closestTranspose = undefined;
    let minDistance = undefined;
    for (let matchingTranspose in samplers) {
        matchingTranspose = parseInt(matchingTranspose);
        let distance = Math.abs(transpose - matchingTranspose);
        if (closestTranspose === undefined) {
            closestTranspose = matchingTranspose;
            minDistance = distance;
            continue;
        }
        
        if (distance < minDistance) {
            closestTranspose = matchingTranspose;
            minDistance = distance;
        }
    }
    return parseFloat(closestTranspose);
}


export function findClosestByOctave(transpose, samplers) {
    let note = Notes.fromTranspose(transpose);
    note.octave = 0;

    let closestTranspose = undefined;
    let minDistance = undefined;
    let minNormalizedDistance = undefined;

    for (let t in samplers) {
        let possibleNote = Notes.fromTranspose(t);
        possibleNote.octave = 0;

        let normalizedDistance = Math.abs(note.getTranspose() - possibleNote.getTranspose());
        let distance = Math.abs(transpose - t);

        if (minNormalizedDistance === undefined ||
            (normalizedDistance < minNormalizedDistance ||
             (normalizedDistance === minNormalizedDistance && 
              distance < minDistance)))
        {
            closestTranspose = t;
            minNormalizedDistance = normalizedDistance;
            minDistance = distance;
        }
    }

    return parseFloat(closestTranspose);
}
